import { render } from "./PasswordUpdateView.vue?vue&type=template&id=b81fc1b0&scoped=true"
import script from "./PasswordUpdateView.vue?vue&type=script&lang=js"
export * from "./PasswordUpdateView.vue?vue&type=script&lang=js"

import "./PasswordUpdateView.vue?vue&type=style&index=0&id=b81fc1b0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81fc1b0"]])

export default __exports__